import "./NewsPage.css";
import InfoSingle from "../../InfoSingle/InfoSingle";
import { fetchInfoSingleData } from "../../../fetchFromDB";
import { useState,useEffect } from "react";

export default function NewsPage() {
    const [infoSingleDataArray, setInfoSingleDataArray] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await fetchInfoSingleData();
                setInfoSingleDataArray(data);
            } catch (error) {
                console.error("Failed to load events", error);
            }
        };
        loadData();
    }, []);

    const recentDateSortArray = [...infoSingleDataArray].sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
    });

    return(
        <div className="news-page">
            <h1>News and Events</h1>
            <div className="news-page-infosingle-grid">
                {recentDateSortArray.map(notice => <InfoSingle styling={{showTextDetails: true}} page_addressOnly={true} {...notice}/>)}
            </div>
        </div>
    )
}